import { useTranslation } from 'react-i18next';
import useLanguage from 'hooks/useLanguage';
import { ICurrentLang } from './type';
import { LanguageService } from 'services/language';
import { useTenantInfo } from 'hooks/useTenantInfo';

export default function useLocales() {
  const { tenantSiteLanguages } = useTenantInfo();
  const { i18n, t } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const { LANGS } = useLanguage(tenantSiteLanguages);

  // Ensure we have a valid language to use as default
  const defaultLang = LANGS[0] || LANGS[1];
  const globalLang = LANGS[1]?.icon1 || defaultLang.icon1;

  // Find the current language or use default
  const currentLang: ICurrentLang =
    LANGS.find((_lang) => _lang.value === langStorage) || defaultLang;

  const handleChangeLanguage = async (newlang: string) => {
    localStorage.setItem('i18nextLng', newlang);
    await i18n.changeLanguage(newlang);
    try {
      await LanguageService.setAccountLanguage(newlang);
    } catch (e) {
      // Optionally handle error (e.g., show notification)
    }
  };

  return {
    onChangeLang: handleChangeLanguage,
    t,
    currentLang,
    allLang: LANGS,
    globalLang
  };
}
